export default __webpack_public_path__ + "static/article-5-9ccaf1949be9c89b4be12c95b7f33d37.jpg";